import React, { useRef, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Person2Icon from '@mui/icons-material/Person2';
import LoginOutlinedIcon from '@mui/icons-material/LoginOutlined';
import DashboardCustomizeOutlinedIcon from '@mui/icons-material/DashboardCustomizeOutlined';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import {
	Box,
	Divider,
	Typography,
	Stack,
	MenuItem,
	IconButton,
} from '@mui/material';
import MenuPopover from '../../../shared/components/menuPopover';
import {
	ClearUtilitiesStorage,
	getFirstName,
	getUser,
	Logout,
} from '../../../../../../services/authService';
import { useNavigate } from 'react-router-dom';

const MENU_OPTIONS = [
	{
		label: 'Dashboard',
		icon: <DashboardCustomizeOutlinedIcon />,
		linkTo: '/',
	},
];

export default function AccountPopover() {
	const navigate = useNavigate();
	const anchorRef = useRef(null);

	const [open, setOpen] = useState(null);

	const user = getUser();

	const handleOpen = (event) => {
		setOpen(event.currentTarget);
	};

	const handleClose = () => {
		setOpen(null);
	};

	const logout = () => {
		handleClose();
		Logout();
		navigate('/login');
	};

	const clearLocalStorage = () => {
		ClearUtilitiesStorage();
		window.location.reload();
	};

	return (
		<>
			<IconButton
				className="!bg-white shadow-xl"
				ref={anchorRef}
				color={open ? 'primary' : 'default'}
				onClick={handleOpen}
				sx={{
					width: 35,
					height: 35,
					p: 0,
					...(open && {
						'&:before': {
							zIndex: 1,
							content: "''",
							width: '100%',
							height: '100%',
							borderRadius: '50%',
							position: 'absolute',
						},
					}),
				}}>
				<Person2Icon className="!text-[#6a6a6a]"></Person2Icon>
			</IconButton>
			<MenuPopover
				open={Boolean(open)}
				anchorEl={open}
				onClose={handleClose}
				sx={{
					p: 0,
					mt: 1.5,
					ml: 0.75,
					'& .MuiMenuItem-root': {
						typography: 'body2',
						borderRadius: 0.75,
					},
				}}>
				<Box sx={{ my: 1.5, px: 2.5 }}>
					<Typography
						variant="subtitle2"
						noWrap>
						{getFirstName()}
					</Typography>
					<Typography
						variant="body2"
						sx={{ color: 'text.secondary' }}
						noWrap>
						{user.email}
					</Typography>
				</Box>

				<Divider sx={{ borderStyle: 'dashed' }} />

				<Stack sx={{ p: 1 }}>
					{MENU_OPTIONS.map((option) => (
						<MenuItem
							sx={{ px: 1 }}
							key={option.label}
							to={option.linkTo}
							component={RouterLink}
							onClick={handleClose}>
							{option.icon ? option.icon : null}
							<Box sx={{ mx: 1.2 }}>{option.label}</Box>
						</MenuItem>
					))}
				</Stack>
				<Divider sx={{ borderStyle: 'dashed' }} />
				<MenuItem
					onClick={() => clearLocalStorage()}
					sx={{ m: 1, px: 1 }}>
					<CleaningServicesIcon />
					<Box sx={{ mx: 1.2 }}>Clear Cache</Box>
				</MenuItem>
				<Divider sx={{ borderStyle: 'dashed' }} />
				<MenuItem
					onClick={() => logout()}
					sx={{ m: 1, px: 1 }}>
					<LoginOutlinedIcon className="text-red-500" />
					<Box
						className="text-red-500"
						sx={{ mx: 1.2 }}>
						Logout
					</Box>
				</MenuItem>
			</MenuPopover>
		</>
	);
}
